import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getPaymentProcessInfo = async (
  processId,
  storeCommitKey = "MFITT"
) => {
  let response;
  try {
    //retry 5 times and wait for 3s every time.
    for (let i = 0; i < 5; i++) {
      try {
        response = await apiWrapper("GET", "processes/" + processId, {}, true);
        console.log(`/processes/${processId} response::`, response);
      } catch (apiError) {
        console.log(`/processes/${processId} error::`, apiError);
      } finally {
        if (
          response?.data?.result == "success" ||
          response?.data?.result == "error"
        ) {
          break;
        } else if (i < 4) {
          //retry if there is no final result
          await new Promise((resolve) => {
            setTimeout(resolve, 3000);
          });
        }
      }
    }

    //ticketing/setPaymentProcessInfo
    //MFITT/setBookingResult
    if (
      response?.data?.result == "success" ||
      response?.data?.result == "error"
    ) {
      if (storeCommitKey == "MFITT") {
        store.commit("MFITT/setBookingResult", response.data);
      } else {
        //storeCommitKey == "ticketing"
        store.commit("ticketing/setPaymentProcessInfo", response.data);
      }
    } else {
      //timeout if there is no final result
      if (storeCommitKey == "MFITT") {
        store.commit("MFITT/setBookingResult", { result: "timeout" });
      } else {
        //storeCommitKey == "ticketing"
        store.commit("ticketing/setPaymentProcessInfo", { result: "timeout" });
      }
    }
  } catch (err) {
    console.log('ERROR"" getPaymentProcessInfo():', err);
    throw err;
  }
};
